import Vue from 'vue';

const chatEventBus = new Vue();

export default chatEventBus;
